/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ProgramDocumentType = 'prescription';

export const ProgramDocumentType = {
    Prescription: 'prescription' as ProgramDocumentType
};

